import {XauditModel} from '../xaudit.model';
import {FeeCodeToothConfiguration} from './fee-code-tooth.configuration';

export class FeeCodeForToothConfiguration extends XauditModel {
  Code: string;
  Description: string;
  Teeth: FeeCodeToothConfiguration[] = [];
}
